<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
    <div class ="navbar-search" v-if="adminShow">
      <el-row>
        <el-col :span="5">
          <el-select v-model="cardForm.type" size="small"  placeholder="请选择" >
            <el-option label="ICCID" value="1"></el-option>
            <el-option label="MSISDN" value="2"></el-option>
            <el-option :label="$t('app.navbar.numberSegment')" value="3" ></el-option>
          </el-select>
        </el-col>
        <template v-if="cardForm.type == 3 ">
          <el-col :span="8" :offset="1">
            <el-input size="small" clearable  :placeholder="$t('app.navbar.enterStartSegment')" v-model="cardForm.startIccid" ></el-input>
          </el-col>
          <el-col :span="8">
            <el-input size="small" clearable :placeholder="$t('app.navbar.enterEndSegment')" v-model="cardForm.endIccid" ></el-input>
          </el-col> 
        </template>
        <template v-if="cardForm.type == 1 ">
          <el-col :span="16" :offset="1">
            <el-input size="small" clearable   :placeholder="$t('app.navbar.enterIccid')" v-model="cardForm.number" ></el-input>
          </el-col>
        </template>
        <template v-if="cardForm.type == 2 ">
          <el-col :span="16" :offset="1">
            <el-input size="small"  clearable  :placeholder="$t('app.navbar.enterMsisdn')" v-model="cardForm.number" ></el-input>
          </el-col>
        </template>
        <el-col :span="2">
          <el-button size="small" icon="el-icon-search" @click="submitSearch" ></el-button>
        </el-col>
      </el-row>
    </div>
    <div class="right-menu">
      <template v-if="device!=='mobile'">
        <el-select 
          v-model="currentLang" 
          @change="handleLangChange" 
          class="right-menu-item hover-effect"
          size="small"
          style="width: 150px; margin-right: 10px;"
        >
          <el-option label="简体中文" value="zh"></el-option>
          <el-option label="English" value="en"></el-option>
          <el-option label="Português" value="pt"></el-option>
        </el-select>
        <el-badge class="right-menu-item hover-effect" v-hasPermi="['taskCenter:down']">
          <el-button size="small" icon="el-icon-download" @click.native="missionCenter" >{{ $t('app.navbar.downloadManagement') }}</el-button>
        </el-badge>
        <el-badge :hidden="messages == 0" :value="messages" :max="10" class="right-menu-item hover-effect badge-message" v-hasPermi="['system:person:message']">
          <el-button size="small" icon="el-icon-message-solid" @click.native="messageCenter" >{{ $t('app.navbar.messageCenter') }}</el-button>
        </el-badge>
      </template>
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
          <span class="el-dropdown-link">
            {{name}}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="handleAccount" v-hasPermi="['system:person:userAccount']">{{ $t('app.navbar.accountCenter') }}</el-dropdown-item>
            <el-dropdown-item @click.native="systemtopUp" v-hasPermi="['system:person:systemCharge']">{{ $t('app.navbar.systemRecharge') }}</el-dropdown-item>
            <el-dropdown-item @click.native="changePasswordDialog">{{ $t('app.navbar.changePassword') }}</el-dropdown-item>
            <el-dropdown-item @click.native="rechargePassword" v-hasPermi="['system:person:chargePassword']">{{ $t('app.navbar.rechargePassword') }}</el-dropdown-item>
            <el-dropdown-item @click.native="quotaModify" v-hasPermi="['system:person:limitUpdate']">{{ $t('app.navbar.quotaModify') }}</el-dropdown-item>
            <el-dropdown-item @click.native="payAccountList" v-hasPermi="['system:person:limitUpdate']">{{ $t('app.navbar.paymentStats') }}</el-dropdown-item>
            <el-dropdown-item @click.native="platformSettingButton" v-hasPermi="['system:person:platformSetting']">{{ $t('app.navbar.platformSetting') }}</el-dropdown-item>
            <el-dropdown-item @click.native="handleApiDoc" v-hasPermi="['agent:apiDoc']" v-show="agentShow">{{ $t('app.navbar.apiDoc') }}</el-dropdown-item>
            <el-dropdown-item   @click.native="logout">{{ $t('app.navbar.safeLogout') }}</el-dropdown-item>
            <el-dropdown-item v-if="!!adminToken" @click.native="backUser">{{ $t('app.navbar.backToOriginalAccount') }}</el-dropdown-item>
          </el-dropdown-menu>
      </el-dropdown>
      <el-dialog :title="$t('app.navbar.changePassword')" :visible.sync="isDefault" @close="dialogClose" :lock-scroll="false" v-dialogDrag width="460px" append-to-body :close-on-click-modal="false">
        <el-form :model="form" label-width="150px" ref="form" :rules="rules">
          <el-form-item :label="$t('app.navbar.oldPassword')" prop="oldPassword" >
            <el-input v-model="form.oldPassword" autocomplete="off" style="width: 260px" :placeholder="$t('app.navbar.enterOldPassword')" type="password"></el-input>
          </el-form-item>
          <el-form-item :label="$t('app.navbar.newPassword')" prop="newPassword" >
            <el-input v-model="form.newPassword" autocomplete="off" style="width: 260px" :placeholder="$t('app.navbar.enterNewPassword')" type="password"></el-input>
          </el-form-item>
          <el-form-item :label="$t('app.navbar.confirmPassword')" prop="confirmPassword" >
            <el-input v-model="form.confirmPassword" autocomplete="off" style="width: 260px" :placeholder="$t('app.navbar.confirmNewPassword')" type="password"></el-input>
          </el-form-item>
        </el-form>
        <div class="dialog-footer" slot="footer">
          <el-button type="primary" @click="dialogClose">{{ $t('app.navbar.cancel') }}</el-button>
          <el-button type="success" @click="submit">{{ $t('app.navbar.save') }}</el-button>
        </div>
      </el-dialog>
      <!-- api接口文档 -->
      <el-dialog :title="$t('app.navbar.interfaceDocumentation')" :visible.sync="openApi" width="800px" append-to-body :close-on-click-modal="false">
        <el-descriptions  direction="vertical" :column="3" border>
          <el-descriptions-item label="APPID/UserId">{{apiData.userId}}</el-descriptions-item>
          <el-descriptions-item :label="$t('app.navbar.secretKey')">
            <el-alert
              :title="$t('app.navbar.contactAdminForSecret')"
              type="warning"
              show-icon
              :closable="false"
              >
            </el-alert>
          </el-descriptions-item>
          <el-descriptions-item :label="$t('app.navbar.documentDownload')">
            <el-link type="primary" @click="apiDown">{{ $t('app.navbar.juziApiDoc') }}</el-link>
          </el-descriptions-item>
        </el-descriptions>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeApi">{{ $t('app.navbar.cancel') }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import { changePassWord } from "@/api/api.js";
import { setToken,removeAdminToken } from '@/utils/auth'
import { cardExist,apiAgent ,reviewShipmentCount , reviewEntrepotCount} from "@/api/api.js";


import webSocketService from '@/utils/WebSocketService';
import messageHandler from '@/utils/MessageHandler';
export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  data() {
    const equalToPassword = (rule, value, callback) => {
      if (this.form.newPassword !== value) {
        callback(new Error(this.$t('app.navbar.passwordsNotMatch')));
      } else {
        callback();
      }
    };
    return {
      currentLang: localStorage.getItem('app_language') || 'zh',
      adminToken:undefined,
      cardForm:{
        type: '1',
        number: ''
      },
      form: {
        oldPassword: undefined,
        newPassword: undefined,
        confirmPassword: undefined
      },
      rules:{
        oldPassword:[
          { required: true, message: this.$t('app.navbar.enterOldPassword'), trigger: "blur" },
        ],
        newPassword:[
          { required: true, message: this.$t('app.navbar.enterNewPassword'), trigger: "blur" },
          { min: 6, max: 10, message: this.$t('app.navbar.passwordLengthTip'),trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: this.$t('app.navbar.confirmPasswordNotEmpty'), trigger: "blur" },
          { required: true, validator: equalToPassword, trigger: "blur" }
        ]
      },
      openApi:false,
      apiData:{},
      initMessageInterval: null,
      //临时放这里
      isConnected: false,
      authFailed:false,
      authFailureReason:'',
      errorLogs:[],
    }
  },
  computed: {
    ...mapGetters([
      'messages',
      'sidebar',
      'avatar',
      'device',
      'isDefault',
      'name'
    ]),
    adminShow(){
      return this.$store.getters.user.userType =='1'
    },
    agentShow(){
      return this.$store.getters.user.userType =='2';
    }
  },
  beforeUnmount() {
    // 组件卸载前清除定时器，避免内存泄漏
    if (this.initMessageInterval) {
      clearInterval(this.initMessageInterval);
    }
  },
  beforeDestroy() {
    // 清理资源
    webSocketService.disconnect();
  },
  methods: {
    // 额度修改
    quotaModify(){
      this.$router.push('/user/limitUpdate')
    },
    // 收款账号信息
    payAccountList(){
      this.$router.push('/user/payAccountList')
    },
    // 跳转消息中心
    messageCenter(){
      this.$router.push('/user/messageCenter')
    },
    //跳转任务中心
    missionCenter(){
      this.$router.push('/taskCenter/missionList')
    },
    // 跳转平台设置
    platformSettingButton(){
      this.$router.push('/platformSetting/setting')
    },
    // 修改密码弹窗
    changePasswordDialog(){
      this.$store.commit("SET_PASSWORD_DEFAULT", true)
      this.resetForm("form");
    },
    dialogClose(){
      this.$store.commit("SET_PASSWORD_DEFAULT", false)
      this.resetForm("form");
    },
     // 修改密码弹窗保存
    submit(){
      this.$refs.form.validate(valid => {
        if (valid) {
          let _this = this
          changePassWord(this.form).then(res => {
            _this.dialogClose()
            this.$message({
              message: "修改密码成功",
              type: "success",
              duration: 1500,
              onClose:function(){
                //退出重新登录
                _this.$store.dispatch('LogOut').then(() => {
                  // location.href = '/';
                  const currentOrigin = window.location.origin;
                  if (window.location.pathname.includes('/web/')) {
                    location.href = `${currentOrigin}/web/`;
                  } else {
                    location.href = currentOrigin;
                  }
                })
              }
            });
          })
        }
      })
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    // 账户信息
    handleAccount(){
      this.$router.push('/user/account')
    },
    // 充值密码设置
    rechargePassword(){
      this.$router.push("/user/rechargePassword");
    },
    // 系统充值
    systemtopUp(){
      this.$router.push("/user/systemPay");
    },
     // 注销
    async logout() {
      this.$confirm(this.$t('app.navbar.confirmLogout'), this.$t('app.navbar.tip'), {
        confirmButtonText: this.$t('app.navbar.confirm'),
        cancelButtonText: this.$t('app.navbar.cancel'),
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          // let indexUrl = this.$store.getters.indexPage;
          // location.href = '/';
          const currentOrigin = window.location.origin;
          if(window.location.pathname.includes('/web/')){
              location.href = `${currentOrigin}/web/`;
          }else{
            location.href = currentOrigin;
          }
        })
      }).catch(() => {});
    },
    backUser(){
      setToken(this.adminToken);
      removeAdminToken();
      window.location.href = window.location.origin;
    },
    initMessage(){
      this.$store.dispatch('UnreadMessage');
    },
    submitSearch(){
      if(!this.cardForm.type){
        this.$message.error(this.$t('app.navbar.pleaseSelectSearchContent'));
        return;
      }
      if(this.cardForm.type == 1){
        if(!this.cardForm.number){
          this.$message.error(this.$t('app.navbar.enterCardNumber'));
          return;
        }
        if(this.cardForm.number.length<8 || this.cardForm.number.length>20){
          this.$message.error(this.$t('app.navbar.cardNumberLengthTip'));
          return;
        } 
      }
      if(this.cardForm.type == 2){
        if(!this.cardForm.number){
          this.$message.error("请输入正确的msisdn");
          return;
        }
      }
      if(this.cardForm.type == 3){
        if(!this.cardForm.startIccid && this.cardForm.endIccid){
          this.$message.error("起始号段和结束号段不能同时为空");
          return;
        }
        if(!!this.cardForm.startIccid && this.cardForm.startIccid.length<18){
          this.$message.error("起始号段不能小于18位");
          return;
        }
        if(!!this.cardForm.endIccid && this.cardForm.endIccid.length<18){
          this.$message.error("结束号段不能小于18位");
          return;
        }
      }
      //判断是否存在
      if(this.cardForm.type== 3){
          this.$router.push({name: 'cards', params: {startIccid: this.cardForm.startIccid,endIccid:this.cardForm.endIccid}});
      }else{
        let params = {
          number:this.cardForm.number,
          type:this.cardForm.type
        }
        cardExist(params).then(res=>{
          let card = res.data.data;
          //直接跳转  国际卡判断
          if(card.operationName == '国际'){
              this.$router.push({path:"/international/internationalDetail",query:{iccid: card.iccid}});
          }else if(card.operationName == '多网'){
            this.$router.push({path:"/card/multiNet/info",query:{groupNo: card.iccid}});
          }else{
              this.$router.push({path:"/card/detail",query:{iccid: card.iccid}});
          }
          
        })
      }
      
    },
    //api接口对接
    handleApiDoc(){
      this.openApi = true;
      apiAgent().then(res=>{
          this.apiData = res.data.data;
      })
    },
    //api文档下载
    apiDown(){
      this.download('/api/apiDown', {
      }, `桔子智联对接文档.docx`)
    },
    closeApi(){
      this.openApi = false;
    },
    notificationTip(){
      //当月25号
      let current = new Date();
      current.setDate(25);
      let next = new Date();
      next.setMonth(next.getMonth() + 1); // 增加一个月
      next.setDate(5);

      if(current.getTime()<new Date().getTime() && new Date().getTime()<next.getTime()){
        this.$alert('<p>尊敬的用户，您好！</p><p style="text-indent:2em;line-height: 2;color: #333">月初月末为系统业务受理高峰期，平台业务办理可能存在延迟，请勿短时间内重复提交订单，避免系统卡单。建议您提前进行业务办理，避免业务办理延时影响业务使用，谢谢！如有需求，可通过公众号<strong>【桔子智联】</strong>联系<strong>[在线客服]</strong>反馈，谢谢！</p>', '消息提醒',{
          showConfirmButton:false,
          roundButton:true,
          dangerouslyUseHTMLString:true,
          customClass: 'message-tip',
          closeOnClickModal:true,
          showConfirmButton:true,
          confirmButtonText:'好的，知道了'
        });
      }

    },
    handleShipmentUpdate(data) {
      this.$store.dispatch('updateShipmentCount', data);
    },
    handleEntrepotUpdate(data) {
      this.$store.dispatch('updateEntrepotCount', data);
    },
    websocket(){
      // 注册消息处理器
      this.registerMessageHandlers();
      webSocketService.init();
      // 将所有需要处理连接成功的消息的组件都注册到onConnect回调中
      webSocketService.onConnect((message) => {
        this.isConnected = true;
        this.username = message.username;
      });
      //消息断开处理
      webSocketService.onDisconnect((event) => {
        this.isConnected = false;
        if (!this.authFailed) {
          console.log('WebSocket连接已断开', event);
        }
      });
      
      // 注册错误处理
      webSocketService.onError((error) => {
        this.addErrorLog({
          type: error.type || 'WebSocket错误',
          message: error.message || '发生未知错误',
          details: error.details || JSON.stringify(error, null, 2),
          timestamp: Date.now()
        });
      });
      
      // 注册认证失败回调 token可能过期 移除重新登录
      webSocketService.onAuthFailure((reason) => {
        this.isConnected = false;
        this.authFailed = true;
        this.authFailureReason = reason || '认证失败，请重新登录';
        localStorage.removeItem('token');
      });
      
      // 订阅主题
      this.subscribeToTopics();
    },
    registerMessageHandlers() {
      // 注册发货申请处理器
      messageHandler.registerHandler('MESSAGE', '/topic/shipment', (payload) => {
        return {
          type: 'shipmentData',
          data: payload
        };
      }); 
      // 注册出库单申请处理器
      messageHandler.registerHandler('MESSAGE', '/topic/entrepot', (payload) => {
        return {
          type: 'entrepotData',
          data: payload
        };
      }); 
      
      // 注册系统通知处理器
      messageHandler.registerHandler('SYSTEM_NOTIFICATION', null, (payload) => {
        return {
          type: 'systemNotification',
          data: payload
        };
      });
    },
    subscribeToTopics() {
      // 订阅发货申请
      const unsubscribeShipment = webSocketService.subscribe(
        '/topic/shipment', 
        (processedMsg, originalMsg) => {
          if (processedMsg.type === 'shipmentData') {
            //按理这里应该直接pyload 统计数据  不能再去查询数据
            this.handleShipmentData(processedMsg.data);
          }
        }   
      );
      //订阅出库单申请
      const unsubscribeEntrepot = webSocketService.subscribe(
        '/topic/entrepot', 
        (processedMsg, originalMsg) => {
          if (processedMsg.type === 'entrepotData') {
            this.handleEntrepotData(processedMsg.data);
          }
        }
      );
      // 订阅系统通知（全局消息）
      webSocketService.onGlobalMessage((processedMsg) => {
        if (processedMsg.type === 'systemNotification') {
          this.handleSystemNotification(processedMsg.data);
        }else if (processedMsg.type === 'error') {
          this.addErrorLog({
            type: '服务器错误',
            message: processedMsg.data.message || '服务器返回错误',
            timestamp: Date.now()
          });
        }
      });

      // 组件销毁时取消订阅
      this.$once('hook:beforeDestroy', () => {
        //订阅主体会返回取消主题的函数
        unsubscribeShipment();
        unsubscribeEntrepot();
      });
    },
    /**
     * 处理发货数据
     */
    handleShipmentData() {
      reviewShipmentCount().then(res=>{
        this.handleShipmentUpdate(res.data.data)
      })
    },
    /**
     * 处理出库单数据
     */
    handleEntrepotData() {
      reviewEntrepotCount().then(res=>{
        this.handleEntrepotUpdate(res.data.data)
      })
    },
    /**
     * 处理系统通知
     */
    handleSystemNotification(data) {
      this.systemNotices.push({
        title: data.title || '系统通知',
        content: data.content,
        type: data.type || 'info'
      });
      // 只保留最近5条通知
      if (this.systemNotices.length > 5) {
        this.systemNotices.shift();
      }
    },
    /**
     * 添加错误日志
     */
    addErrorLog(log) {
      this.errorLogs.unshift(log);
      // 只保留最近10条错误日志
      if (this.errorLogs.length > 10) {
        this.errorLogs.pop();
      }
    },
    
    /**
     * 清除错误日志
     */
    clearErrorLogs() {
      this.errorLogs = [];
    },
    handleLangChange(lang){
      this.$i18n.locale = lang
      localStorage.setItem('app_language', lang)
      window.location.reload()
    }
  },
  created() {
    this.$i18n.locale = localStorage.getItem('app_language') || 'zh'
    this.notificationTip();
    this.initMessage();
    this.initMessageInterval = setInterval(() => {
      this.initMessage();
    }, 3 * 60 * 1000);
    this.adminToken = this.$store.getters.adminToken;
    if(this.adminShow){
      this.websocket()
      this.handleShipmentData()
      this.handleEntrepotData()
    }
  }
}
</script>
<style>
  .message-tip {
      width: 550px !important;
  }
  .message-tip  .el-message-box__btns{
    text-align: center;
  }
</style>
<style lang="scss" scoped>
.badge-message {
  margin-right: 20px;
}
::v-deep .el-badge__content.is-fixed{
  top: 15px;
  right: 15px;
}
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .topmenu-container {
    position: absolute;
    left: 50px;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .navbar-search{
    float: left;
    margin-left: 46px;
    height: 100%;
    line-height: 50px;

  }
  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
